<template>
  <v-dialog
    max-width="800px"
    v-model="state.console_open">
    <v-card
      class="pa-3"
      style="flex-direction: column; transition: all 0.3s; border-radius: 16px">
      <div
        style="
          height: 480px;
          padding: 14px;
          overflow-y: auto;
          display: flex;
          background-color: var(--main-bg-color);
          color: var(--v-primary-base);
          flex-direction: column-reverse;
          border-radius: 16px;
        ">
        <div
          v-for="(line, i) in state.console_history"
          :key="(line, i)">
          <pre v-if="!line.data_type">{{ line.console_result }}</pre>
          <pre v-else-if="line.data_type === 'json'">
            {{ JSON.stringify(line.console_result, null, 2) }}
            </pre
          >
          <v-img
            style="border-radius: 7px; background: black"
            class="pa-3"
            v-else-if="line.data_type === 'base64/jpeg'"
            :src="'data:image/jpeg;base64,' + line.console_result">
            <v-btn
              @click="
                downloadImage('data:image/jpeg;base64,' + line.console_result)
              ">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-img>
        </div>
      </div>
      <div
        style="
          padding: 10px;
          border-top: solid;
          border-color: #ffffff33;
          display: flex;
        ">
        <input
          type="text"
          v-on:keyup.enter="SendConsoleCmd()"
          placeholder="Type a command... (e.g. 'help')"
          autofocus
          ref="console_input"
          style="
            border: 0px none;
            flex: 1;
            margin-right: 10px;
            padding-left: 10px;
          "
          v-model="console_cmd" />
        <v-btn
          dark
          small
          @click="SendConsoleCmd()"
          variant="outlined">
          Send
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import { state, deluge_sock } from '../../stores/deluge.js';
import { deluge } from '../../stores/deluge.js';

const console_input = ref(null);
const console_cmd = ref('');

function downloadImage(url) {
  var a = document.createElement('a');
  a.href = url;
  a.download = 'screenshot.jpeg';
  a.click();
}
function SendConsoleCmd() {
  if (console_cmd.value === '') return;
  if (console_cmd.value === 'enable_beta') {
    localStorage.setItem('enable_beta', true);
    state.beta = true;
  }
  if (console_cmd.value === 'disable_beta') {
    localStorage.setItem('enable_beta', false);
    state.beta = false;
  }
  if (console_cmd.value === 'version') {
    state.console_history.push({
      console_result: deluge.canvaspro_core_info.full_version,
      data_type: null,
    });
    console_cmd.value = '';
    return;
  }
  var split_cmd = console_cmd.value.match(/(?:[^\s"]+|"[^"]*")+/g);
  var cmd = { cmd: split_cmd[0], args: split_cmd.slice(1) };
  deluge_sock.value.send(JSON.stringify(cmd));
  console_cmd.value = '';
}
watch(console_cmd, (new_val) => {
  if (new_val.includes('`')) {
    console_cmd.value = new_val.replace('`', '');
  }
});
onMounted(() => {
  console_input.value.focus();
});
</script>
